import { useEffect } from 'react';
import { enableNativePullToRefreshAtTop } from '../../utils/device/native-pull-to-refresh.util';

/** Allows the app's pull-to-refresh only while `scroller` is scrolled to the top. */
export function useNativePullToRefreshAtTop(scroller: HTMLElement | null) {
	useEffect(() => (scroller ? enableNativePullToRefreshAtTop(scroller) : undefined), [scroller]);
}
